import React, { createContext, useState } from "react";

const MenuContext = createContext({
  isOpen: false,
  setIsOpen: (newIsOpen: boolean) => {},
});

// Creating a provider component
const MenuProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MenuContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </MenuContext.Provider>
  );
};

export { MenuContext, MenuProvider };
